import axios from 'axios';

const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/usuarios';

const usuariosApi = {
    listado: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            if (Array.isArray(response.data) && Array.isArray(response.data[0])) return response.data[0];
            return Array.isArray(response.data) ? response.data : (response.data?.data || []);
        } catch (error) {
            console.error('Error fetching usuarios:', error);
            return [];
        }
    },

    crear: async (data: any) => {
        const response = await axios.post(`${BASE_URL}/crear`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        return response.data;
    },

    editar: async (id: number | string, data: any) => {
        const response = await axios.put(`${BASE_URL}/editar/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        return response.data;
    },

    desactivar: async (id: number | string, solicitanteId: number | string) => {
        const response = await axios.put(`${BASE_URL}/baja/${id}`, { solicitanteId }, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        return response.data;
    },

    reactivar: async (id: number | string, solicitanteId: number | string) => {
        const response = await axios.put(`${BASE_URL}/reactivar/${id}`, { solicitanteId }, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        return response.data;
    },

    obtenerSupervisor: async (usuarioIdAsignado: number | string) => {
        try {
            const response = await axios.get(`https://inventariosbackend.velasresorts.com/inventarios/supervisores/${usuarioIdAsignado}`);
            if (Array.isArray(response.data) && Array.isArray(response.data[0])) return response.data[0];
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            // 404 = no tiene jefe asignado todavía, no es un error real.
            return [];
        }
    },

    asignarSupervisor: async (userId: number | string, usuarioIdAsignado: number | string) => {
        const response = await axios.post(
            'https://inventariosbackend.velasresorts.com/inventarios/supervisores/crear',
            { userId, usuarioIdAsignado },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        );
        return response.data;
    }
};

export default usuariosApi;
